export const isObject = (obj) =>
  typeof obj === 'object' && !Array.isArray(obj) && obj !== null

export function nodesToArray(nodeList) {
  if (!nodeList || nodeList.length === 0) {
    return []
  }

  return Array.prototype.slice.call(nodeList)
}

/**
 * Get viewport width
 * @return {[type]} [description]
 */
export function getViewportWidth() {
  return Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
}

/**
 * Get viewport height
 * @return {[type]} [description]
 */
export function getViewportHeight() {
  return Math.max(
    document.documentElement.clientHeight,
    window.innerHeight || 0
  )
}

/**
 * Get element data attributes in an object
 * @param  {Element} el
 * @return {Object} dataObject
 */
export function getElData(el) {
  if (el.dataset) {
    return JSON.parse(JSON.stringify(el.dataset))
  }

  const dataObject = {}
  const dataRegEx = /^data-(.+)$/

  nodesToArray(el.attributes, function (attribute) {
    if (dataRegEx.test(attribute.nodeName)) {
      const key = attribute.nodeName.match(dataRegEx)[1]
      dataObject[key] = attribute.nodeValue
    }
  })

  return dataObject
}

/**
 * Remove element
 * @param  {Element} el
 */
export function removeElement(el) {
  if (el.parentNode) {
    el.parentNode.removeChild(el)
  }
}

/**
 * debounce
 * Delay execution of function
 */
export function debounce(func, wait, immediate) {
  var timeout
  return function () {
    var context = this,
      args = arguments
    var later = function () {
      timeout = null
      if (!immediate) func.apply(context, args)
    }
    var callNow = immediate && !timeout
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
    if (callNow) func.apply(context, args)
  }
}

export function getStyleProperty(property, element, forcePX = false) {
  property = property || ''
  element = element || document.documentElement

  const value = window.getComputedStyle(element).getPropertyValue(property)

  return forcePX ? parseFloat(value) * 16 : value
}

export function urlIsFile(url) {
  return url.split('/').pop().indexOf('.') > -1
}

export function toHHMMSS(string) {
  const secNum = parseInt(string, 10)
  let hours = Math.floor(secNum / 3600)
  let minutes = Math.floor((secNum - hours * 3600) / 60)
  let seconds = secNum - hours * 3600 - minutes * 60

  if (minutes < 10) {
    minutes = '0' + minutes
  }

  if (seconds < 10) {
    seconds = '0' + seconds
  }

  if (hours < 10) {
    hours = '0' + hours
  }

  return hours + ':' + minutes + ':' + seconds
}

export function padNumber(nr) {
  nr = Number(nr)

  if (nr < 10) {
    nr = '0' + nr
  }

  return String(nr)
}

/**
 * Save to local storage with fallback if storage is full
 */
export function setLocalStorageItem(key, data) {
  try {
    window.localStorage.setItem(key, data)
  } catch (e) {
    window.localStorage.clear()
    window.localStorage.setItem(key, data)
  }
}

const supportDOMParser = (function () {
  if (!window.DOMParser) return false

  const parser = new DOMParser()

  try {
    parser.parseFromString('x', 'text/html')
  } catch (err) {
    return false
  }
  return true
})()

export function stringToElements(string) {
  if (supportDOMParser) {
    const parser = new DOMParser()
    const doc = parser.parseFromString(string, 'text/html')
    return doc.body.childNodes[0]
  }

  const dom = document.createElement('div')
  dom.innerHTML = string
  return dom.childNodes[0]
}

export function randomBetween(min = 0, max = 1, not = null) {
  let nr = null

  while (nr === not) {
    nr = Math.floor(Math.random() * (max - min + 1)) + min
  }

  return nr
}

export function randomBetweenDecimals(min, max, decimalPlaces) {
  var rand =
    Math.random() < 0.5
      ? (1 - Math.random()) * (max - min) + min
      : Math.random() * (max - min) + min // could be min or max or anything in between
  var power = Math.pow(10, decimalPlaces)
  return Math.floor(rand * power) / power
}

// function shuffleArray(arr) {
//   var m = arr.length,
//     t,
//     i

//   // While there remain elements to shuffle…
//   while (m) {
//     // Pick a remaining element…
//     i = Math.floor(Math.random() * m--)

//     // And swap it with the current element.
//     t = arr[m]
//     arr[m] = arr[i]
//     arr[i] = t
//   }

//   return arr
// }

export const shuffleArray = (list) => {
  for (let i = list.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    const temp = list[i]
    list[i] = list[j]
    list[j] = temp
  }

  return list
}

export const randomFromArray = (list = [], count = 1) => {
  return shuffleArray(list).filter((_, index) => index < count)
}
